import { useEffect, useState, lazy, Suspense } from "react";
import axios from "axios";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import baseUrl from "./services/base-url";

// Lazily load route components to reduce initial bundle size
const CategoryPage = lazy(() => import("./pages/CategoryPage/CategoryPage"));
const ProfilePage = lazy(() => import("./pages/ProfilePage/ProfilePage"));
const SearchPage = lazy(() => import("./pages/SearchPage/SearchPage"));
// const DashboardPage = lazy(() => import("./pages/DashboardPage/DashboardPage"));
const AllCategoryPage = lazy(() => import("./pages/AllCategoryPage/AllCategoryPage"));
const LoginPage = lazy(() => import("./pages/LoginPage/LoginPage"));
const HomePage = lazy(() => import("./pages/HomePage/HomePage"));
const ProductDetails = lazy(() => import("./pages/ProductDetails/ProductDetails"));


export default function App() {
  const token = localStorage.getItem("access_token");
  const navigate = useNavigate();
  const [checkingToken, setCheckingToken] = useState(true);

  useEffect(() => {
    async function verifyToken() {
      if (!token) {
        navigate("/login");
        setCheckingToken(false);
        return;
      }

      try {
        const controller = new AbortController();
        const res = await axios.get(`${baseUrl}/verify-token`, {
          headers: { Authorization: `Bearer ${token}` },
          signal: controller.signal,
        });

        if (res.status === 200) {
          if (res.data.expired) {
            localStorage.removeItem("access_token");
            navigate("/login");
          }
        } else {
          localStorage.removeItem("access_token");
          navigate("/login");
        }
      } catch (error) {
        // Ignore cancellations; handle genuine errors
        if (error && error.code === "ERR_CANCELED") {
          return;
        }
        localStorage.removeItem("access_token");
        navigate("/login");
      } finally {
        setCheckingToken(false);
      }
    }

    verifyToken();
  }, [token, navigate]);

  if (checkingToken) {
    return null; // keep minimal while token is being verified
  }

  return (
    <Suspense fallback={null}>
      <Routes>
        {token ? (
          <Route path="/" element={<Navbar />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="original/:code" element={<ProductDetails />} />
            <Route path="replacement/:code" element={<ProductDetails />} />
            <Route path="category/:name" element={<CategoryPage />} />
            <Route path="profile" element={<ProfilePage />} />
            {/* <Route path="dashboard" element={<DashboardPage />} /> */}
            <Route path="all-categories" element={<AllCategoryPage />} />
            <Route path="/product/:code" element={<ProductDetails />} />
            <Route path="/login" element={<Navigate to="/" />} />
          </Route>
        ) : (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" />} />
          </>
        )}
      </Routes>
    </Suspense>
  );
}

